document.addEventListener("DOMContentLoaded", function() {
var endlessScroll = new Ajaxinate({
  container: '#blog-grid',
  pagination: '#AjaxinatePagination',
  method: 'click',
  offset: 1000
});
});

document.addEventListener("click", function(event) {
  if (event.target && event.target.matches(".tabvs_all_wraper p.blogs-tabs-data")) {
    var tabs = document.querySelectorAll(".tabvs_all_wraper p.blogs-tabs-data");
    tabs.forEach(function(tab) {
      tab.classList.remove("is__active");
    });
    event.target.classList.add("is__active");
    var tabs_url = event.target.getAttribute("tag-url");
    var xhr = new XMLHttpRequest();
    xhr.open("GET", tabs_url, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var html_data = xhr.responseText;
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html_data;
        var newContent = tempDiv.querySelector('.final_article_content').innerHTML;
        document.querySelector('.final_article_content').innerHTML = newContent;
        var endlessScroll = new Ajaxinate({
  container: '#blog-grid',
  pagination: '#AjaxinatePagination',
  method: 'click',
  offset: 1000
});
      }
    };
    xhr.send();
  }
});

